/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { LinkArr, Next, Prev } from "../../common/svg/AllSvg";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";

const Order = ({ line }: any) => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const { t } = useTranslation('common');
    const arrowRef: any = useRef(null);
    const navigate = useNavigate();
    const params = useParams();
    const loaderData: any[] = [1, 2, 3, 4, 5]
    // const data: any[] = [
    //     { id: 1, name: "Food & Beverages", desc: "Satisfy your cravings with tasty treats.", img: require("../../../assets/images/prod1.png") },
    //     { id: 2, name: "Electronics & Gadgets", desc: "Get the newest tech at your fingertips.", img: require("../../../assets/images/prod2.png") },
    //     { id: 3, name: "Fashion & Apparel", desc: "Stylish outfits just a tap away!", img: require("../../../assets/images/prod3.png") },
    //     { id: 4, name: "Books & Stationery", desc: "Discover great reads and office supplies.", img: require("../../../assets/images/prod4.png") },
    //     { id: 5, name: "Electronics & Gadgets", desc: "Get the newest tech at your fingertips.", img: require("../../../assets/images/prod5.png") }
    // ]

    const settings = {
        dots: false,
        variableWidth: true,
        arrows: false,
        infinite: data?.length > 3 ? true : false
    }

    const getCategory = async () => {
        try {
            setLoading(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.store_category}`);

            if (res && res?.status === 200) {
                setData(res?.data)
                setLoading(false);
            }
        } catch (error) {
            setLoading(false)
            console.error("error while feching category data", error);
        }
    };

    useEffect(() => {
        !!lang && getCategory();
    }, [lang])

    return (
        <>
            {data?.length > 0 && <div className="mb-[30px] lg:mb-[70px] xlx:mb-[117px] w-full overflow-hidden">
                <div className="container w-full flex flex-col gap-[30px] lg:gap-[40px] xlx:gap-[50px]">
                    <div className="w-full flex justify-between gap-[15px] sm:gap-[25px] sm:flex-row flex-col">
                        <div className="flex flex-col">
                            <h3 className="text-blackDark dark:text-white font-bold">{t("passenger.home.order.title")}</h3>
                            <h1 className="font-bold sm:max-w-[510px]">{lang === "en" ? <><span className="text-[#AE8639]">{t("passenger.home.order.subtitle")} </span><span className="text-secPurple dark:text-white">{line?.name}</span></> : lang === "hi" ? <><span className="text-[#AE8639]">मेट्रो <span className="text-secPurple dark:text-white">{line?.name}</span> के भीतर सुपरफास्ट डिलीवरी </span></> : <><span className="text-[#AE8639]">मेट्रो <span className="text-secPurple dark:text-white">{line?.name}</span> अंतर्गत सुपरफास्ट डिलिव्हरी </span></>} </h1>
                        </div>

                        <div className="flex flex-col">
                            <h2 className="text-blackDull dark:text-textBlackDull font-medium sm:max-w-[395px] text-base leading-snug">{t("passenger.home.order.desc")}</h2>

                            <h2 className="text-blackDull dark:text-textBlackDull font-medium sm:max-w-[395px] text-base leading-snug mt-[15px]">{t("passenger.home.order.desc_sub")}</h2>

                            <button className="flex items-center gap-[8px] text-[#AE8639] dark:text-[#6294FF] font-bold mt-[8px] hover:underline focus:underline" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/stores`) : navigate(`/stores`)}><h5>{t("passenger.home.order.shop_now")}</h5> <LinkArr className="fill-[#AE8639] dark:fill-[#6294FF]" /></button>
                        </div>
                    </div>

                    {loading ?
                        <Slider className='h-full flex w-[100vw]' ref={arrowRef} {...settings}>
                            {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                                <div className="pr-[10px] lg:pr-[15px] xlx:pr-[20px] animate-pulse" key={index}>
                                    <div className="relative w-[220px] h-[248px] lg:w-[250px] lg:h-[278px] xlx:w-[300px] xlx:h-[328px] rounded-[20px] bg-gray-200 dark:bg-gray-700">
                                    </div>
                                </div>
                            ))}
                        </Slider>
                        :
                        <>
                            {data?.length > 0 && <Slider className='h-full flex w-[100vw]' ref={arrowRef} {...settings}>
                                {Array.isArray(data) && data?.map((item: any, index: number) => (
                                    <div className="pr-[10px] lg:pr-[15px] xlx:pr-[20px]" key={index}>
                                        <div className="relative w-[220px] h-[248px] lg:w-[250px] lg:h-[278px] xlx:w-[300px] xlx:h-[328px] rounded-[20px]">
                                            <div style={{ background: "linear-gradient(180deg, rgba(14, 16, 13, 0.00) 0%, #000 100%)" }} className="absolute rounded-[20px] top-0 left-0 right-0 bottom-0 w-full h-full p-[15px] lg:p-[20px] xlx:p-[25px] flex flex-col justify-end gap-[4px] md:gap-[8px] xlx:gap-[10px]">
                                                <h3 className="text-white font-bold max-w-[160px]">{item?.name}</h3>
                                                {/* <h4 className="text-[#DCDCDC] dark:text-[#DBDBDB] font-semibold text-sm leading-snug">{item?.desc}</h4> */}
                                            </div>

                                            <img src={item?.primary_image?.file} alt={item?.name} className="rounded-[20px] w-[220px] h-[248px] lg:w-[250px] lg:h-[278px] xlx:w-[300px] xlx:h-[328px]" />
                                        </div>
                                    </div>
                                ))}
                            </Slider>}
                        </>
                    }

                    {data?.length > 0 && <div className="flex items-center gap-[8px] justify-end w-full pb-[2px]">
                        <button aria-label={t("aria_label.prev_arr")} title={t("aria_label.prev")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickPrev()}>
                            <Prev className="fill-[#3D3D3D] !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                        </button>
                        <button aria-label={t("aria_label.next_arr")} title={t("aria_label.next")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickNext()}>
                            <Next className="fill-[#3D3D3D] !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                        </button>
                    </div>}

                </div>

            </div>}
        </>
    );
};

export default Order;